<div class="seats-config-dialog">
    <button class="btn-close-dialog" (click)="onCancel()" title="Cerrar">
        <i class="fa-light fa-xmark"></i>
    </button>
    <div class="main-seats-config">
        <h1 class="title-seats-config">Nueva sección de butacas</h1>
        <p class="subtitle">Define el número de filas y columnas. Podrás ajustar cada asiento después.</p>

        <div class="form-new-section">
            <div class="input-group-seat">
                <div class="seat-input-icon">
                    <i class="fa-light fa-arrow-down-to-line"></i>
                </div>
                <div class="w-100">
                    <p class="label-input">Filas</p>
                    <div class="form-input-container">
                        <input type="number" class="w-100" [(ngModel)]="data.rows" min="1" max="50" placeholder="Ej: 15" [required]="true">
                    </div>
                </div>
            </div>
            <div class="input-group-seat">
                <div class="seat-input-icon">
                    <i class="fa-light fa-arrow-right-to-line"></i>
                </div>
                <div class="w-100">
                    <p class="label-input">Columnas</p>
                    <div class="form-input-container">
                        <input type="number" class="w-100" [(ngModel)]="data.columns" min="1" max="50" placeholder="Ej: 12" [required]="true">
                    </div>
                </div>
            </div>
        </div>

        <div class="seat-count-badge">
            <i class="fa-light fa-loveseat"></i>
            <span>{{ getTotalSeats() }} asientos en total</span>
        </div>
    </div>

    <mat-divider></mat-divider>
    <div class="footer-seats-config">
        <div class="btn-new btn-create btn-create-border m-0" (click)="onCancel()">
            <p class="m-0">Cancelar</p>
        </div>
        <div class="btn-new btn-create m-0" (click)="onCreate()">
            <p class="m-0">Añadir sección</p>
        </div>
    </div>
</div>